import { any, nullable, number, object, string, TypeOf } from 'zod';

/* ---------------------------- NoContentResponse --------------------------- */

export const NoContentResponse = nullable(object({}));
export type NoContentResponse = TypeOf<typeof NoContentResponse>;

/* ---------------------------- ApiErrorResponse ---------------------------- */

export const ApiErrorResponse = object({
    key: string(),
    description: string(),
    name: string(),
    data: any().optional(),
    status: number().optional(),
});
export type ApiErrorResponse = TypeOf<typeof ApiErrorResponse>;
